/* eslint-disable @typescript-eslint/no-useless-constructor */
import { StoreConfig, EntityStore, EntityState } from '@datorama/akita';
import { Injectable } from '@angular/core';
import { IActivityStatus } from 'typings/doenkids/doenkids';

export interface IActivityStatusState extends EntityState<IActivityStatus> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'activity-status' })
export class ActivityStatusStore extends EntityStore<IActivityStatusState, IActivityStatus> {
  constructor() {
    super();
  }
}
